import React from 'react'
import PropTypes from 'prop-types'

// This component is from https://reactjs.org/docs/error-boundaries.html
class PortalErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { 
      hasError  : false, 
      errorInfo : null,
      error     : null,
    }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { error, hasError: true, }
  }

  componentDidCatch (error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.setState({ errorInfo, error, })
  }
  
  render () {
    if (this.state.hasError) {
      // eslint-disable-next-line no-undef
      const errorString = <>An error has occurred. If you feel this is a system fault or it is preventing you from completing a program, please contact CCW at <a href={'mailto:info@careerconnectwa.org'}>info@careerconnectwa.org</a></>
      return <div style={{ marginLeft: '10%', marginRight: '10%', }}>
        <h1>Something went wrong.</h1><br/>
        <p>{errorString}</p>
        <details style={{ whiteSpace: 'pre-wrap', }}>
          { this.state.error && this.state.error.toString() }
          <br/>
          { this.state.errorInfo && this.state.errorInfo.componentStack }
        </details>
      </div>
    }
    return this.props.children 
  }
}

PortalErrorBoundary.propTypes = {
  children: PropTypes.node,
}
export default PortalErrorBoundary